import React from 'react';
import { useTranslation } from 'react-i18next';
import type { RootState } from '@store/root-reducer';

import { PreviewButton } from '../preview-button';
import type { ZkProof } from '../types';
import { ZkProofBlock } from '../zk-proof-block';

type SdkOptions = NonNullable<RootState['docsVerification']['sdkOptions']>;

type OrganizationFinishProps = {
    icon: React.ReactNode;
    title: string;
    sdkOptions?: SdkOptions;
    isWeb3?: boolean;
    isLoading: boolean;
    verified?: boolean;
    zkProof?: ZkProof;
    zkProofError: string;
};

export const OrganizationFinish: React.FC<OrganizationFinishProps> = ({
    icon,
    title,
    sdkOptions,
    isWeb3,
    isLoading,
    verified,
    zkProof,
    zkProofError,
}) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <div className='icon'>{icon}</div>
            <div className='header'>
                <h3 className='finish-title'>{title}</h3>
                <p className='finish-description'>
                    {sdkOptions?.settings?.finish_screen_settings?.enabled
                        ? sdkOptions?.settings?.finish_screen_settings?.main_text
                        : t('docVerificationWidget.finish.title.youUploadedAllDocuments')}
                </p>
                <p className='finish-description'>
                    {!sdkOptions?.settings?.finish_screen_settings?.enabled &&
                        t('docVerificationWidget.finish.subtitle.youUploadedAllDocuments')}
                </p>
            </div>
            {!isWeb3 && <PreviewButton />}
            <ZkProofBlock
                isWeb3={isWeb3}
                isLoading={isLoading}
                verified={verified}
                zkProof={zkProof}
                zkProofError={zkProofError}
            />
        </React.Fragment>
    );
};
